import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { loadFestivalsApiFirst } from '../../utils/cmsContentLoader';
import { HOME_FEATURED_FESTIVALS } from '../../data/homePageData';

function HomeFestivalsBand() {
	const [festivals, setFestivals] = useState(HOME_FEATURED_FESTIVALS);

	useEffect(() => {
		loadFestivalsApiFirst()
			.then((list) => {
				if (!list.length) return;
				const featured = list
					.filter((f) => f.typical_month)
					.slice(0, 6)
					.map((f) => ({
						slug: f.slug,
						month: f.typical_month,
						name: f.name,
						summary: f.tagline || f.summary,
					}));
				if (featured.length > 0) setFestivals(featured);
			})
			.catch(() => {});
	}, []);

	return (
		<section className="home-festivals-band" aria-labelledby="home-festivals-title">
			<div className="home-festivals-band__inner container">
				<div className="home-festivals-band__head">
					<div>
						<p className="home-festivals-band__eyebrow">Culture &amp; timing</p>
						<h2 id="home-festivals-title" className="home-festivals-band__title">Festival calendar</h2>
						<p className="home-festivals-band__lead">
							Dashain, Tihar, Holi, and dozens more — dates shift yearly on the lunar calendar.
						</p>
					</div>
					<Link to="/festivals" className="home-festivals-band__all">
						All festivals →
					</Link>
				</div>
				<div className="home-festivals-band__grid">
					{festivals.map((f) => (
						<Link key={f.slug} to={`/festivals/${f.slug}`} className="home-festivals-band__card">
							<span className="home-festivals-band__month">{f.month}</span>
							<strong className="home-festivals-band__name">{f.name}</strong>
							<span className="home-festivals-band__summary">{f.summary}</span>
						</Link>
					))}
				</div>
			</div>
		</section>
	);
}

export default HomeFestivalsBand;
